/**
 * Backwards-compatible alias of `styles/theme.ts`.
 *
 * The form module historically had its own token table. To avoid
 * drift, both modules now resolve to the same `colors` object. New
 * code should import from `styles/theme` directly.
 */
import { colors, gradients } from '../../styles/theme';

export const tokens = {
  navy: colors.navy,
  navyLight: colors.navyLight,
  gold: colors.gold,
  goldLight: colors.goldLight,
  goldOnLight: colors.goldOnLight,
  surface: colors.surface,
  surfaceMuted: colors.surfaceMuted,
  border: colors.border,
  controlBorder: colors.controlBorder,
  borderError: colors.dangerBorder,
  textPrimary: colors.textPrimary,
  textMuted: colors.textMuted,
  textLabel: colors.textLabel,
  textPlaceholder: colors.textPlaceholder,
  successBg: colors.successBg,
  successBorder: colors.successBorder,
  successText: colors.successText,
  errorBg: colors.errorBg,
  errorBorder: colors.errorBorder,
  errorText: colors.errorText,
  infoBg: colors.infoBg,
  infoBorder: colors.infoBorder,
  infoText: colors.infoText,
  disabledBg: colors.disabledBg,
  disabledText: colors.disabledText,
} as const;

export const goldGradient = gradients.gold;
export const navyGradient = gradients.navy;
